var exports = {
  "Nr": "ActivitySummaryCard.module__card___YTU0V2",
  "Iv": "ActivitySummaryCard.module__cover___YTU0V2",
  "pq": "ActivitySummaryCard.module__info___YTU0V2",
  "dw": "ActivitySummaryCard.module__stage___YTU0V2",
  "$": "ActivitySummaryCard.module__titleRow___YTU0V2",
  "UU": "ActivitySummaryCard.module__name___YTU0V2",
  "h5": "ActivitySummaryCard.module__status___YTU0V2",
  "qr": "ActivitySummaryCard.module__footer___YTU0V2",
  "c0": "ActivitySummaryCard.module__people___YTU0V2",
};

module.exports = exports;
